/*
Monotype Foundry Platform API
Version 1.0.0

Definition: DesignersCheckUnique

Properties:
  designers: array
*/

var DesignersCheckUnique = (function () {
  function validateDesignersCheckUnique (arg) {
    // Validate designers
    if (arg.designers && !(Array.isArray(arg.designers))) {
      throw new Error('DesignersCheckUnique.designers: Wrong type: Got \'' + (typeof arg.designers) + '\', but expected: \'array\'')
    }
  }
  function buildDesignersCheckUnique (arg) {
    var DesignersCheckUnique = arg
    // Complete designers
    // Expected Type: array
    DesignersCheckUnique.designers = DesignersCheckUnique.designers || []
    return DesignersCheckUnique
  }
  return {
    validate: validateDesignersCheckUnique,
    build: buildDesignersCheckUnique
  }
})()

module.exports = DesignersCheckUnique
